// @view
import React from 'react';

export default function TextWithNewLines({ text, ...props }) {
  return <pre style={props}>{text}</pre>;
}
